import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../http/http.service';
import { ConstantUtil } from '../util/constant.util';

@Injectable({
  providedIn: 'root'
})
export class ChannelService {
  constructor(private readonly httpService: HttpService) {}

  /**
   * 绑定渠道 - 通用接口
   * @param bindData 绑定数据
   * @returns Observable
   */
  bindChannel(bindData: any): Observable<any> {
    return this.httpService.post(ConstantUtil.ADMIN_SERVICENUMBER_CHANNEL_BIND, bindData);
  }

  /**
   * 解绑渠道 - 通用接口
   * @param serviceNumberId 服务号ID
   * @param channelType 渠道类型
   * @returns Observable
   */
  unbindChannel(serviceNumberId: string, channelType: string): Observable<any> {
    return this.httpService.post(ConstantUtil.ADMIN_SERVICENUMBER_CHANNEL_UNBIND, {
      serviceNumberId,
      channelType
    });
  }

  /** 更新服務號 LINE 群組外發開關。 */
  updateLineGroupSendConfig(serviceNumberId: string, allowLineGroupSend: boolean | null): Observable<any> {
    return this.httpService.post(ConstantUtil.ADMIN_SERVICENUMBER_CHANNEL_LINE_GROUP_SEND_CONFIG, {
      serviceNumberId,
      allowLineGroupSend
    });
  }

  /**
   * 绑定 LINE Login
   * @param serviceNumberId 服务号ID
   * @param channelSecret 访问令牌
   * @param providerId 渠道提供者ID
   * @param channelId 渠道ID
   * @returns Observable
   */
  bindLineLogin(serviceNumberId: string, channelId: string, channelSecret: string, providerId: string): Observable<any> {
    const data = {
      channelType: 'Line',
      lineChannelType: 'Login',
      lineDto: {
        serviceNumberId,
        channelId,
        channelSecret,
        providerId
      }
    };
    return this.bindChannel(data);
  }

  /**
   * 解绑 LINE Login
   * @param serviceNumberId 官方服务号ID
   * @returns Observable
   */
  unbindLineLogin(serviceNumberId: string): Observable<any> {
    return this.httpService.post(ConstantUtil.ADMIN_SERVICENUMBER_CHANNEL_UNBIND, {
      serviceNumberId,
      channelType: 'Line',
      lineChannelType: 'Login'
    });
  }

  /**
   * 绑定 Facebook 渠道
   * @param pageData Facebook页面数据
   * @param serviceNumberId 服务号ID
   * @returns Observable
   */
  bindFacebookChannel(pageData: any, serviceNumberId: string): Observable<any> {
    const bindData = {
      serviceNumberId,
      channelType: 'Facebook',
      facebookDto: {
        code: pageData.id,
        accessToken: pageData.access_token,
        pictureUrl: pageData.pictureUrl,
        serviceNumberId: serviceNumberId
      }
    };
    return this.bindChannel(bindData);
  }

  /**
   * 绑定 Instagram 渠道
   * @param pageData Instagram页面数据
   * @param serviceNumberId 服务号ID
   * @returns Observable
   */
  bindInstagramChannel(pageData: any, serviceNumberId: string): Observable<any> {
    const bindData = {
      serviceNumberId,
      channelType: 'Instagram',
      instagramDto: {
        code: pageData.id,
        groupCode: pageData.group_code,
        groupName: pageData.group_name,
        accessToken: pageData.access_token,
        pictureUrl: pageData.pictureUrl,
        serviceNumberId: serviceNumberId
      }
    };
    return this.bindChannel(bindData);
  }

  /**
   * 绑定 LINE 渠道
   * @param channelId 渠道ID
   * @param channelSecret 渠道密钥
   * @param providerId 渠道提供者ID
   * @param serviceNumberId 服务号ID
   * @returns Observable
   */
  bindLineChannel(channelId: string, channelSecret: string, providerId: string, serviceNumberId: string): Observable<any> {
    const data = {
      serviceNumberId,
      channelType: 'Line',
      lineDto: {
        channelId,
        channelSecret,
        providerId
      }
    };
    return this.bindChannel(data);
  }
}
